import PropTypes from 'prop-types';

import { getClassNames } from '../../../utils/util';

import './button.scss';

const Button = ({ className, children, onClick, type, disabled, secondary }) => {
  return (
    <button
      className={`${getClassNames('button', { secondary })} ${getClassNames(className, { secondary })}`}
      onClick={onClick}
      type={type}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

Button.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired,
  type: PropTypes.string,
  disabled: PropTypes.bool,
  secondary: PropTypes.bool,
};

Button.defaultProps = {
  className: '',
  type: undefined,
  disabled: false,
  secondary: false,
};

export default Button;
